export default __webpack_public_path__ + "static/media/astronaut-mobile@3x.5a57b323.jpg";